export default "__VITE_PUBLIC_ASSET__6befc38c__"